// extracted by mini-css-extract-plugin
module.exports = {"staticRectangle":"index_staticRectangle_2lFY1","backgroundImage":"index_backgroundImage_3xRyU"};